import React from "react";
import { NavLink} from 'react-router-dom';

import ExecutorNav from './ExecutorNav';
import CustomerNav from './CustomerNav';
import LeftNavContent from '../Commons/LeftNavContent';

const LeftContent = (props) => {
    const { option, id } = props;

	return(
        <LeftNavContent>
            <h2 className="left-content__title">
                <span className={option === "contractor" ? "text_gradient_violet_circle" : "text_gradient_violet_circle disabled"} style={{marginRight: "20px"}}>Список</span>
                <span className={option !== "contractor" ? "text_gradient_orange" : "text_gradient_orange disabled"}>заказов</span>
            </h2>

            <div className="radios-slider big-radios-slider">
                <NavLink className={`radio`} to="/orders/contractor">
                    <label htmlFor="option1">Исполнитель</label>
                </NavLink>
                <NavLink exact className={`radio ${option === "customer" ? 'active' : ''}`}  to="/orders">
                    <label htmlFor="option1">Заказчик</label>
                </NavLink>
            </div>

            {
                option === "contractor"
                ? <ExecutorNav id={id}/>
                : <CustomerNav id={id}/>
            }
        </LeftNavContent>
	)
}
export default LeftContent;


// WEBPACK FOOTER //
// ./src/components/Orders/LeftContent.js